module.exports = __webpack_public_path__ + "sw-pc-resize.jpg?48b60d41fce2b25dead0f0d0c323b1b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sw-pc-resize.jpg
// module id = 334
// module chunks = 0